import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import { useExperiment } from '@/libraries/experiment';
import GridRowLabel from '@/features/buybox/components/grid/GridRowLabel.vue';
import PreRollVideoAd from './components/PreRollVideoAd.vue';
import type { TitleDetail } from '@/interfaces/title-details-graphql';
import type { SnowplowContext } from '@/helpers/tracking/providers';
import type { CatalogueItem } from '@/helpers/promotion-helper';


export default /*#__PURE__*/_defineComponent({
  __name: 'GridPreRollExp',
  props: {
    title: null,
    catalogueItem: null,
    providerShortName: null,
    shortName: null,
    isFreeBuyBox: { type: Boolean },
    additionalContexts: null,
    trackingContexts: null,
    seasonNumber: null,
    episodeNumber: null
  },
  setup(__props: any) {

const GridSwiperFreeTrial = () => import('@/components/experiments/GridSwiperExp/GridSwiperFreeTrial.vue');
const GridPreRollExpBannerAd = () =>
	import('@/components/experiments/PreRollAndStaticBBAdsExp/components/GridPreRollExpBannerAd.vue');
const GridPromotionSwiper = () => import('@/components/experiments/GridSwiperExp/components/GridPromotionSwiper.vue');
const GridQTV = () => import('@/components/experiments/GridSwiperExp/GridQTV.vue');

const v2AdFilled = ref<boolean | null>(null);



const { activeVariantWithControlGroup: variant } = useExperiment('EXP_PRE_ROLL_GRID');

const isV1 = computed(() => variant.value === 'variant_1');
const isV2 = computed(() => variant.value === 'variant_2');
const isV3 = computed(() => variant.value === 'variant_3');

return { __sfc: true,GridSwiperFreeTrial, GridPreRollExpBannerAd, GridPromotionSwiper, GridQTV, v2AdFilled, variant, isV1, isV2, isV3, GridRowLabel, PreRollVideoAd }
}

})